import { create } from 'zustand';

import {
  createWorkspaceSidebarPushSlice,
  type WorkspaceSidebarPushSlice,
} from '~/components/v2/store/features/workspace/slices/createWorkspaceSidebarPushSlice';

export type WorkspaceSidebarPushState = WorkspaceSidebarPushSlice;

export const useWorkspaceSidebarPushStore = create<WorkspaceSidebarPushState>()((...args) => ({
  ...createWorkspaceSidebarPushSlice()(...args),
}));
